import { LanguageEnum } from 'graphql-common';

const { VITE_ENVIRONMENT } = import.meta.env;

export function getLangLabel(lang: LanguageEnum) {
  switch (lang) {
    case LanguageEnum.En:
      return 'English';
    case LanguageEnum.Fr:
      return 'Français';
    case LanguageEnum.Ro:
      return 'Română';
    case LanguageEnum.Uk:
      return 'Українська';
    case LanguageEnum.Pl:
      return 'Polski';
    case LanguageEnum.Es:
      return 'Español';
    default:
      return '-';
  }
}

const fullLangs = Object.values(LanguageEnum);
const langs =
  VITE_ENVIRONMENT === 'DEV'
    ? fullLangs
    : [LanguageEnum.En, LanguageEnum.Fr, LanguageEnum.Es];

export const langOptions = langs.map((lang) => ({
  label: getLangLabel(lang),
  value: lang,
}));
